import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Camera"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-camera',
    templateUrl: './icon-camera.component.html',
    styleUrls: ['./icon-camera.component.scss'],
    standalone: false
})
export class IconCameraComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
